import Vue from 'vue';
import { Component, Prop, Inject } from 'vue-property-decorator';
import TeamMemberCard from '@/common/interfaces/modules/TeamMemberCard';
import TitleIconComponent from '@/components/TitleIcon/TitleIcon.vue';
import lineClamp from 'vue-line-clamp';

@Component({
  components: {
    TitleIcon: TitleIconComponent,
    lineClamp,
  },
})
export default class PersonalCardComponent extends Vue {
  @Prop({ type: Object as () => TeamMemberCard })
  card!: TeamMemberCard;

  maxLinesQuantity: number = 3;

  @Inject()
  openModal!: (card: TeamMemberCard) => void;

  openModalFn() {
    this.openModal(this.card);
  }
}
